import { useReducer } from "react";
import isEqual from "react-fast-compare";
import { shouldLog } from "utils/shouldLog";

const reducer = (state, action) => {
  switch (action.type) {
    case "SET_LIVEMESSAGES":
      let lm = {};
      lm[action.values.mtopic] = action.values.liveMessages;
      let newLiveMessages = { ...state.liveMessages, ...lm };
      if (isEqual(state.liveMessages, newLiveMessages)) return state;
      return {
        ...state,
        liveMessages: { ...state.liveMessages, ...lm }
      };
    case "REMOVE_SEND":
      if (
        isEqual(
          state.liveSendMessages,
          (state.liveSendMessages || []).filter(
            (m) => m.smid !== action.values.smid
          )
        )
      )
        return state;
      return {
        ...state,
        liveSendMessages: (state.liveSendMessages || []).filter(
          (m) => m.smid !== action.values.smid
        )
      };
    case "ADD_SEND":
      let lsm = state.liveSendMessages || [];
      let smidList = lsm.map((m) => m.smid);
      let newLiveSendMessages = lsm.concat(
        (action.values.liveSendMessages || []).filter(
          (m) => !smidList.includes(m.smid)
        )
      );
      if (isEqual(state.liveSendMessages, newLiveSendMessages)) return state;
      return {
        ...state,
        liveSendMessages: lsm.concat(
          (action.values.liveSendMessages || []).filter(
            (m) => !smidList.includes(m.smid)
          )
        )
      };
    case "SET_DESCRIPTORSB":
      shouldLog() && console.log("SET_DESCRIPTORSB", action);
      if (isEqual(state.descriptorsB, action.values.descriptorsB)) return state;
      else
        return {
          ...state,
          descriptorsB: action.values.descriptorsB
        };
    case "SET_TOPICDESCRIPTORS":
      if (isEqual(state.topicDescriptors, action.values.topicDescriptors))
        return state;
      else
        return {
          ...state,
          topicDescriptors: action.values.topicDescriptors
        };
    case "SET_TOPICS":
      // console.log(`TESTTIMER: [useTopicsState] SET_TOPICS executed`);
      if (isEqual(state.topics, action.values.topics)) return state;
      else
        return {
          ...state,
          topics: action.values.topics
        };
    case "SET_LOGOS":
      if (isEqual(state.logos, action.values.logos)) return state;
      else
        return {
          ...state,
          logos: { ...state.logos, ...action.values.logos }
        };
    case "SET_LOGO":
      if (
        state.logos &&
        isEqual(state.logos[action.values.mtopic], action.values.logo)
      )
        return state;
      else {
        let logo = {};
        logo[action.values.mtopic] = action.values.logo;
        let newState = {
          ...state,
          logos: { ...state.logos, ...logo }
        };
        // console.log("SET_LOGO!!!", action.values, newState);
        return newState;
      }
    case "SET_UNREAD_DISPLAY":
      if (state.unreadDisplay === action.values.unreadDisplay) {
        return state;
      } else {
        return {
          ...state,
          unreadDisplay: action.values.unreadDisplay
        };
      }
    case "SET_FLAG_DISPLAY":
      if (state.flagDisplay === action.values.flagDisplay) {
        return state;
      } else {
        return {
          ...state,
          flagDisplay: action.values.flagDisplay
        };
      }
    case "SET_LABEL_DISPLAY":
      if (state.labelDisplay === action.values.labelDisplay) {
        return state;
      } else {
        return {
          ...state,
          labelDisplay: action.values.labelDisplay
        };
      }
    case "SET_SHOWTOPIC":
      if (state.showTopic === action.values.showTopic) {
        return state;
      } else {
        return {
          ...state,
          showTopic: action.values.showTopic
        };
      }
    case "SET_MESSAGE_TEXT":
      if (isEqual(state.messageText, action.values.messageText)) return state;
      else
        return {
          ...state,
          messageText: action.values.messageText
        };
    case "SET_WHISPERS":
      if (isEqual(state.whispers, action.values.whispers)) return state;
      else
        return {
          ...state,
          whispers: action.values.whispers
        };
    case "SET_QUOTE_RETAIN":
      if (isEqual(state.quoteRetained, action.values.quoteRetained))
        return state;
      else
        return {
          ...state,
          quoteRetained: action.values.quoteRetained
        };
    case "SET_MARKDOWN":
      if (isEqual(state.markdownSwitch, action.values.markdownSwitch))
        return state;
      else
        return {
          ...state,
          markdownSwitch: action.values.markdownSwitch
        };
    default: {
      return state;
    }
  }
};

const useTopicsState = (state) => {
  const [topicsState, topicsDispatch] = useReducer(reducer, state);
  return { topicsState, topicsDispatch };
};

export default useTopicsState;
